// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleTitleBlock-module--root--2FVzz","prelude":"ArticleTitleBlock-module--prelude--3TQil"};